// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"3262":"UpgradeModal","4614":"Status","4681":"Checkout","6842":"List","8510":"Restricted"}[chunkId] || chunkId) + ".chunk.min.css";
};